import ContentCreate from '@mui/icons-material/Create';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext, useResourceContext } from 'react-admin';
import { Link, LinkProps } from 'react-router-dom';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuEditButtonProps = Omit<ContextMenuButtonProps, 'icon' | 'label'> & {
  linkProps?: Partial<LinkProps>;
};

export const ContextMenuEditButton: React.FC<ContextMenuEditButtonProps> = ({
  linkProps,
  ...restProps
}) => {
  const translate = useTypedTranslate();
  const resourceCurrent = useResourceContext(linkProps);
  const record = useRecordContext(linkProps);
  const { createPathWithQuery } = useCreatePathWithQuery();
  const { resource, ...restLinkProps } = linkProps || {};

  return (
    <Link
      style={{ textDecoration: 'none' }}
      to={createPathWithQuery({
        resource: resource ?? resourceCurrent,
        id: record?.id ?? record?.['@id'],
        type: 'edit',
      })}
      {...restLinkProps}
    >
      <ContextMenuButton
        icon={<ContentCreate fontSize="small" style={{ marginTop: '1px' }} />}
        label={translate('app.buttons.edit')}
        {...restProps}
      />
    </Link>
  );
};
